<template>
<Layout  >
  <h1 class="text-center pb-0 text-xl font-bold text-blue-600 sm:text-left md:text-center lg:text-center xl:text-center"></h1>
<br>

<!--Mobile Version-->
  <div class="block md:hidden lg:hidden">
    <div class="md:hidden lg:hidden xl:hidden sm:visible">
    <div >
<!--<iframe src="https://calendar.google.com/calendar/embed?height=500&wkst=1&ctz=Africa%2FJohannesburg&showPrint=0&mode=AGENDA&src=dGhlZ3JhY2V2MW4zQGdtYWlsLmNvbQ&src=NWIzMjBkZGVlMzYxZTZmMzhkZThjOTZkNGE0ZWMyYzUwYThmZGRmMGM5ODM3ZTgyOWE1M2VlMDE2ZGExZWJiOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23c38437&color=%23f6bf26" style="border:solid 1px #C38437" width="335" height="500" frameborder="0" scrolling="no"></iframe>-->
 
<iframe src="https://calendar.google.com/calendar/embed?height=500&wkst=1&ctz=Africa%2FJohannesburg&showPrint=0&showTitle=0&showTz=0&mode=AGENDA&src=dGhlZ3JhY2V2MW4zQGdtYWlsLmNvbQ&src=NWIzMjBkZGVlMzYxZTZmMzhkZThjOTZkNGE0ZWMyYzUwYThmZGRmMGM5ODM3ZTgyOWE1M2VlMDE2ZGExZWJiOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ZjNmY2U2MTgzN2E4YWNhNDkxNTg4YmU5ZDMyZTJjMTI0N2ZkYTQwMjM1NGY1YTcxYjkzYjM1ZWJiZjk4YTg5NUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=NTVkZGUzOGY0MWE1NzliY2M2ZmEyNGNhMzQxZTUyOTM4OGRjYjczYjg2Nzk3MTY1Njc4NDhkMWFiYTQxNjQ3M0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23c38437&color=%23f6bf26&color=%23c67122&color=%23a79b8e" style="border:solid 1px #C38437" width="335" height="500" frameborder="0" scrolling="no"></iframe>
</div>
  </div>

</div>
<div class="hidden md:block">
<!--<iframe src="https://calendar.google.com/calendar/embed?height=940&wkst=1&ctz=Africa%2FJohannesburg&showPrint=0&src=dGhlZ3JhY2V2MW4zQGdtYWlsLmNvbQ&src=NWIzMjBkZGVlMzYxZTZmMzhkZThjOTZkNGE0ZWMyYzUwYThmZGRmMGM5ODM3ZTgyOWE1M2VlMDE2ZGExZWJiOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23c38437&color=%23f6bf26" style="border:solid 1px #C38437" width="1300" height="940" frameborder="0" scrolling="no"></iframe>-->
<iframe src="https://calendar.google.com/calendar/embed?height=940&wkst=1&ctz=Africa%2FJohannesburg&showPrint=0&showTitle=0&showTz=0&mode=MONTH&src=dGhlZ3JhY2V2MW4zQGdtYWlsLmNvbQ&src=NWIzMjBkZGVlMzYxZTZmMzhkZThjOTZkNGE0ZWMyYzUwYThmZGRmMGM5ODM3ZTgyOWE1M2VlMDE2ZGExZWJiOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ZjNmY2U2MTgzN2E4YWNhNDkxNTg4YmU5ZDMyZTJjMTI0N2ZkYTQwMjM1NGY1YTcxYjkzYjM1ZWJiZjk4YTg5NUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=NTVkZGUzOGY0MWE1NzliY2M2ZmEyNGNhMzQxZTUyOTM4OGRjYjczYjg2Nzk3MTY1Njc4NDhkMWFiYTQxNjQ3M0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23c38437&color=%23f6bf26&color=%23c67122&color=%23a79b8e" style="border:solid 1px #C38437" width="1300" height="940" frameborder="0" scrolling="no"></iframe>
</div>
 </Layout>
</template>



<script>
import Layout from "./layouts/Main";

//import { mapGetters } from "vuex";


export default {
  name: 'Calendar',
  components: { Layout },
  data() {
    return {
      //sermons: {},
      
    };
  },
  created() {
   // this.userData = this.currentUserData;
    //this.type = this.currentUserData.userType;
    //this.userStatus = this.currentUserData.status;
    

  },
    
   
  computed: {
    
  },
   methods: {
    
    
   },

   

   
  //<div v-if="currentUserData.status !== 'approved'">
    //  <TopLoader />
      
    //</div>
};
</script>
